import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    lists: {},
    total_count: '',
    is_no_records: '',
    count: 1,
    list: {},
    Updatelist: {},
    search_criteria: '',
    filter_list: {},
    filter_name: '',
    message: {},
    error: '',
    details: '',
    tag_list: [],
    log_details: '',
    export: {},
    type: '',
    status_code: '',
    status_message: '',
    status_type: '',
    recurringinvoice_index_history:'',
    index_status:''

}
const mutations = {
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.rec_invoice_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_UPDATE_DATA(state, list) {
        state.Updatelist = list
        state.error = ''
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    LIST_DETAILS(state, data) {
        state.details = data
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    STOP_RECURRING(state, data) {
        state.list.recurring_invoice_header_detail.rec_inv_status = data.rec_inv_status
        state.list.recurring_invoice_header_detail.next_inv_date = data.next_inv_date
        state.list.recurring_invoice_header_detail.rec_end_date = data.rec_end_date
        state.message = data.status
        state.type = data.type
        state.list.recurring_invoice_header_detail.rec_inv_status_name = data.rec_inv_status_name
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    MESSAGE_DETAILS(state, data) {
        state.message = data.status
        state.type = data.type
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },

}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.recurringinvoice.getRecurrings(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {


        return AppService.recurringinvoice.getRecurringExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.recurringinvoice.postRecurringInvoice(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, {id,type}) {

        return AppService.recurringinvoice.getRecurringInvoice(id, type,rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchInvList({
        commit,
        rootState
    }, id) {
        return AppService.recurringinvoice.getInvoiceRecurring(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.recurringinvoice.postRecurringInvoiceUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.recurringinvoice.postFiltercreateRecurringInvoice(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.recurringinvoice.postFilterdeleteRecurringInvoice(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.recurringinvoice.postFilterudpateRecurringInvoice(data, id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchViewList({
        commit,
        rootState
    }, id) {

        return AppService.recurringinvoice.getRecurringInvoiceView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.recurringinvoice.postRecurringInvoiceBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleterecurringinvoice({
        commit,
        rootState
    }, data) {

        return AppService.recurringinvoice.getRecurringInvoiceDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    stoprecurringinvoice({
        commit,
        rootState
    }, data) {

        return AppService.recurringinvoice.getRecurringInvoiceStop(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    if(response.data.code==200){
                        commit('STOP_RECURRING', response.data) // getting all the list in the api call
                        }
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkstoprecurring({
        commit,
        rootState
    }, data) {

        return AppService.recurringinvoice.bulkStopRecurring(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_DETAILS', response.data) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

}
export default {
    namespaced,
    state,
    mutations,
    actions
}